import { render, staticRenderFns } from "./UserStatsTable.vue?vue&type=template&id=77c20de2&scoped=true&"
import script from "./UserStatsTable.vue?vue&type=script&lang=ts&"
export * from "./UserStatsTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserStatsTable.vue?vue&type=style&index=0&id=77c20de2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c20de2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer,VTextField})
